import { useEffect, useState, type ReactNode } from 'react';

import { getSession, onAuthStateChange } from '../../features/auth/data/authRepository.js';
import { SessionContext, type SessionState } from './sessionContext.js';

/**
 * Holds the authentication session for the whole app — a genuinely app-wide, low
 * frequency concern (react-pwa-engineering skill 10.6).
 */
export function SessionProvider({ children }: { children: ReactNode }) {
  const [state, setState] = useState<SessionState>({ status: 'loading' });

  useEffect(() => {
    let active = true;

    void getSession().then((session) => {
      if (!active) return;
      setState(session ? { status: 'signedIn', session } : { status: 'signedOut' });
    });

    const unsubscribe = onAuthStateChange((session) => {
      setState(session ? { status: 'signedIn', session } : { status: 'signedOut' });
    });

    return () => {
      active = false;
      unsubscribe();
    };
  }, []);

  return <SessionContext value={state}>{children}</SessionContext>;
}
